// Cache busting utility
export const getCacheBuster = (): string => {
  return `?v=${Date.now()}`;
};

// Add cache buster to URLs
export const addCacheBuster = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_cb=${Date.now()}`;
};

// Force reload with cache clearing
export const forceReload = async (): Promise<void> => {
  await clearAllCaches();
  window.location.reload();
};

// Clear browser cache (if possible)
export const clearCache = (): void => {
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
};

// Check if there's a new version available
export const checkForUpdates = (): void => {
  // Add a timestamp to force fresh fetch
  fetch(`/manifest.json?v=${Date.now()}`)
    .then(response => response.json())
    .then(manifest => {
      const currentVersion = localStorage.getItem('app-version');
      if (currentVersion !== manifest.version) {
        localStorage.setItem('app-version', manifest.version);
        forceReload();
      }
    })
    .catch(() => {
      // If manifest fetch fails, still reload to be safe
      forceReload();
    });
};

// Clear all caches
export const clearAllCaches = async (): Promise<void> => {
  try {
    // Clear browser cache
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      console.log('All caches cleared');
    }

    // Clear service worker cache
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'CLEAR_CACHE'
      });
    }

    // Clear localStorage if needed
    // localStorage.clear();
  } catch (error) {
    console.error('Error clearing caches:', error);
  }
};

// Handle navigation errors
export const handleNavigationError = (): void => {
  console.log('Navigation error detected, attempting to fix...');
  
  // Clear caches and reload
  clearAllCaches().then(() => {
    setTimeout(() => {
      window.location.reload();
    }, 100);
  });
}; 